import { Switch } from '@headlessui/react';
import { Info } from 'lucide-react';

interface PublishingOptionsProps {
  options: {
    access: 'paid_members' | 'public' | 'members';
  };
  onChange: (options: any) => void;
}

export default function PublishingOptions({ options, onChange }: PublishingOptionsProps) {
  return (
    <div className="space-y-8">
      <section>
        <h3 className="text-lg font-semibold mb-4">Post access</h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium">Who can access this post?</p>
              <p className="text-sm text-gray-500">Choose who can view this post.</p>
            </div>
            <select
              value={options.access}
              onChange={(e) => onChange({ ...options, access: e.target.value })}
              className="rounded-md border-gray-300"
            >
              <option value="paid_members">Paid members only</option>
              <option value="members">Paid and unpaid members</option>
              <option value="public">Everyone</option>
            </select>
          </div>
        </div>
      </section>
    </div>
  );
}
